import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress, TablePagination, useTheme, Card,
  CardContent, Avatar, Button, Chip, TextField, MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Cookies from 'js-cookie';
import { AlertError } from '../../component/popupAlert';
import { alpha } from '@mui/material/styles';
import { BsPersonFill } from "react-icons/bs";
import { MdPreview } from "react-icons/md";
import ResponsiveAppBar from '../../component/appbar';
import { DownloadExcelDataRoomBooking, getRoomBookings, getSummaryRoomBooking, getSummaryRoomBookingToday, SearchingRoomBooking } from '../../service/room_service';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

// Styled components for the table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  '&.MuiTableCell-body': {
    fontSize: 14,
    borderBottom: '1px solid #ddd',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

const DashboardRoomTable_view = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const token = Cookies.get('token');
  const [isLoading, setIsLoading] = useState(true);
  const [summaryUser, setSumaryUser] = useState([]);
  const [summaryToday, setSumaryToday] = useState([]);
  const [searchData, setSearchData] = useState({
    roombooking_id: '',
    first_name: '',
    last_name: '',
    datetimeCheckin: null,
    datetimeCheckout: null,
    status: '',
    startDate: null,
    endDate: null,
    packageinfo: null,
  });

  const today = dayjs().locale('th');
  const formattedDate = `${today.format('D')} ${today.format('MMMM')} ${parseInt(today.format('YYYY')) + 543}`;


  const handleReset_s = () => {
    setSearchData({
      roombooking_id: '',
      first_name: '',
      last_name: '',
      datetimeCheckin: null,
      datetimeCheckout: null,
      status: '',
      check_in: null,
      check_out: null,
      packageinfo: null,

    });
  };

  useEffect(() => {
    handleGetSummary();
    handleGetSummaryToday();
    handleGetEmployeeAccount();
  }, []);

  const StatusCard = ({ title, count, icon, color, onClick }) => {
    const theme = useTheme();

    return (
      <Card
        sx={{
          backgroundColor: 'white',
          height: '100%',
          borderRadius: 4,
          position: 'relative',
          overflow: 'hidden',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: theme.shadows[10],
          },
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            background: `linear-gradient(45deg, ${alpha(color, 0.2)}, ${alpha(color, 0.1)})`,
            zIndex: 0,
          }}
        />
        <CardContent
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: 3,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
            <Box>
              <Avatar
                sx={{
                  bgcolor: color,
                  width: 52,
                  height: 52,
                  boxShadow: `0 4px 20px ${alpha(color, 0.5)}`,
                }}
              >
                {icon}
              </Avatar>
              <Typography
                variant="h6"
                marginTop={'18px'}
                sx={{
                  fontWeight: 'medium',
                  color: theme.palette.text.secondary,
                }}
              >
                {title}
              </Typography>
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 'bold',
                color: theme.palette.text.primary,
              }}
            >
              {count}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const getStatusCount = (data, status) => {
    if (!Array.isArray(data)) {
      console.error("summaryUser is not an array or is undefined");
      return 0;
    }
    const item = data.find(item => item.status === status);
    return item ? item.booking_count : 0;
  };

  const handleGetSummary = async () => {
    try {
      const res = await getSummaryRoomBooking(token)
      // console.log('handleGetSummary', res);
      setSumaryUser(res);
    } catch (error) {
      AlertError('เกิดข้อผิดพลาดในการดึงข้อมูล');
    }
  }

  const handleGetSummaryToday = async () => {
    try {
      const res = await getSummaryRoomBookingToday(token);
      console.log('handleGetSummary', res);
      setSumaryToday(res);
    } catch (error) {
      AlertError('เกิดข้อผิดพลาดในการดึงข้อมูล');
    }
  }

  const handleGetEmployeeAccount = async () => {
    try {
      setIsLoading(true);
      const res = await getRoomBookings(token);
      // console.log(res);
      setData(Array.isArray(res) ? res : []); // Ensure data is an array
    } catch (error) {
      setData([]); // Set empty array in case of error
    } finally {
      setIsLoading(false);
    }
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const handleDownload = async () => {
    try {
      const response = await DownloadExcelDataRoomBooking(data, token);
      console.log(response);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const handleChang_s = (e, fieldName) => {
    if (e && e.target) {
      // Handle TextField or MenuItem
      const { name, value } = e.target;
      setSearchData(prevData => ({
        ...prevData,
        [name]: value
      }));
    } else if (fieldName) {
      // Handle DateTimePicker or custom field
      setSearchData(prevData => ({
        ...prevData,
        [fieldName]: e // e in this case is the date value
      }));
    }
  };

  const handleSearch = async (data) => {

    if (data.check_in) {
      data.check_in = dayjs(data.check_in).format('DD-MM-YYYY');
    }

    if (data.endDate) {
      // Convert endDate to a Date object
      let endDate = new Date(data.endDate);

      // Add 1 day
      endDate.setDate(endDate.getDate() + 1);
      data.endDate = endDate;
    }

    try {
      const res = await SearchingRoomBooking(data, token)
      setData(res)
    } catch (e) {
      console.error('SearchingRoomBooking', e)
      AlertError('เกิดข้อผิดพลาด', 'เกิดข้อผิดพลาดในการค้นหาข้อมูล');
    }
  };


  return (
    <Box sx={{ bgcolor: '#ECECEC', }}>
      <ResponsiveAppBar />
      <Box sx={{ flexGrow: 1, p: 3, margin: 4 }}>
        <Typography variant="h4" gutterBottom>
          Room Dashboard
        </Typography>
        {/* <Grid container spacing={2} sx={{ mb: 3, marginTop: '10px' }}>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="จำนวนการจองทั้งหมด"
              count={getStatusCount(summaryUser,"ทั้งหมด")}
              icon={<BsPersonFill />}
              color="#3f51b5"
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="เสร็จสิ้น"
              count={getStatusCount(summaryUser,"เสร็จสิ้น")}
              icon={<BsPersonFill />}
              color="#4caf50"
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="รอให้บริการ"
              count={getStatusCount(summaryUser,"รอให้บริการ")}
              icon={<BsPersonFill />}
              color="#2196f3"
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="รอชำระเงิน"
              count={getStatusCount(summaryUser,"รอชำระเงิน")}
              icon={<BsPersonFill />}
              color="#ff9800"
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="ยกเลิก"
              count={getStatusCount(summaryUser,"ยกเลิก")}
              icon={<BsPersonFill />}
              color="#f44336"
            />
          </Grid>
        </Grid> */}

        <Grid container spacing={2} sx={{ mb: 3, marginTop: '10px' }}>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title={`จำนวนการจอง ${formattedDate}`}
              count={getStatusCount(summaryToday, "ทั้งหมด")}
              icon={<BsPersonFill />}
              color="#3f51b5"
              onClick={() => handleSearch({ check_in: today })}
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="เสร็จสิ้น"
              count={getStatusCount(summaryToday, "เสร็จสิ้น")}
              icon={<BsPersonFill />}
              color="#4caf50"
              onClick={() => handleSearch({ status: 'เสร็จสิ้น', check_in: today })}
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="รอให้บริการ"
              count={getStatusCount(summaryToday, "รอให้บริการ")}
              icon={<BsPersonFill />}
              color="#2196f3"
              onClick={() => handleSearch({ status: 'รอให้บริการ', check_in: today })}
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="รอชำระเงิน"
              count={getStatusCount(summaryToday, "รอชำระเงิน")}
              icon={<BsPersonFill />}
              color="#ff9800"
              onClick={() => handleSearch({ status: 'รอชำระเงิน', check_in: today })}
            />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <StatusCard
              title="ยกเลิก"
              count={getStatusCount(summaryToday, "ยกเลิก")}
              icon={<BsPersonFill />}
              color="#f44336"
              onClick={() => handleSearch({ status: 'ยกเลิก', check_in: today })}
            />
          </Grid>
        </Grid>

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
          <Card sx={{ padding: 3, marginTop: 1, marginBottom: 3 }}>
            <Typography variant="h6" gutterBottom>
              ค้นหารายการจองห้องพัก
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>หมายเลขการจอง</Typography>
                <TextField
                  name="roombooking_id"
                  label="หมายเลขการจอง"
                  value={searchData.roombooking_id}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>ชื่อจริง</Typography>
                <TextField
                  name="first_name"
                  label="ชื่อจริง"
                  value={searchData.first_name}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>แพ็กเกจ</Typography>
                <TextField
                  select
                  name="packageinfo"
                  label="แพ็กเกจ"
                  value={searchData.packageinfo}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                >
                  <MenuItem value="รายชั่วโมง">รายชั่วโมง (1 ชั่วโมง)</MenuItem>
                  <MenuItem value="4 ชั่วโมง">ครึ่งวัน (4 ชั่วโมง)</MenuItem>
                  <MenuItem value="8 ชั่วโมง">เต็มวัน (8 ชั่วโมง)</MenuItem>
                </TextField>
              </Grid>


              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>สถานะ</Typography>
                <TextField
                  select
                  name="status"
                  label="สถานะ"
                  value={searchData.status}
                  onChange={handleChang_s}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                >
                  <MenuItem value="เสร็จสิ้น">เสร็จสิ้น</MenuItem>
                  <MenuItem value="รอให้บริการ">รอให้บริการ</MenuItem>
                  <MenuItem value="รอชำระเงิน">รอชำระเงิน</MenuItem>
                  <MenuItem value="ยกเลิก">ยกเลิก</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>วันเวลาเข้าใช้บริการ</Typography>
                <DatePicker
                  name='startDate'
                  value={searchData.check_in}
                  onChange={(value) => handleChang_s(value, 'startDate')}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true,
                      InputLabelProps: { shrink: true }
                    }
                  }}
                  ampm={true}
                  format="DD/MM/YYYY"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>วันเวลาเข้าใช้บริการ</Typography>
                <DatePicker
                  name='endDate'
                  value={searchData.check_in}
                  onChange={(value) => handleChang_s(value, 'endDate')}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true,
                      InputLabelProps: { shrink: true }
                    }
                  }}
                  ampm={true}
                  format="DD/MM/YYYY"
                />
              </Grid>

            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="outlined"
                color="primary"
                sx={{ marginRight: 2, width: '200px' }}
                onClick={handleReset_s}
              >
                ล้างค่า
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: '200px' }}
                onClick={() => handleSearch(searchData)}
              >
                ค้นหา
              </Button>
            </Box>
          </Card>
        </LocalizationProvider>

        {/* Employee List Table */}
        <Card>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 2
              }}
            >
              <Typography variant="h6" gutterBottom>
                รายการชื่อพนักงาน
              </Typography>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => handleDownload()}
                  sx={{
                    width: '200px',
                    backgroundColor: 'green',
                    '&:hover': { backgroundColor: 'darkgreen' }
                  }}
                >
                  ดาวน์โหลดข้อมูล
                </Button>

                <Button
                  variant="contained"
                  onClick={() => navigate('/thewonderblueadmin_room/create')}
                  sx={{ width: '200px' }}
                >
                  เพิ่มรายการ
                </Button>
              </Box>
            </Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>ลำดับ</StyledTableCell>
                          <StyledTableCell>รหัสการจอง</StyledTableCell>
                          <StyledTableCell>ชื่อ</StyledTableCell>
                          <StyledTableCell>อีเมล</StyledTableCell>
                          <StyledTableCell>เบอร์โทรศัพท์</StyledTableCell>
                          <StyledTableCell>แพ็กเกจ</StyledTableCell>
                          <StyledTableCell>จำนวนชั่วโมง</StyledTableCell>
                          <StyledTableCell>ราคา</StyledTableCell>
                          <StyledTableCell>วันที่</StyledTableCell>
                          <StyledTableCell>เวลาเริ่ม</StyledTableCell>
                          <StyledTableCell>เวลาสิ้นสุด</StyledTableCell>
                          <StyledTableCell>สถาณะ</StyledTableCell>
                          <StyledTableCell>รายละเอียด</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      {Array.isArray(data) && data.length > 0 ? (
                        <TableBody>
                          {data
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((data, index) => (
                              <StyledTableRow key={data.id}>
                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell>{data.roombooking_id}</TableCell>
                                <TableCell>{data.first_name} {data.last_name}</TableCell>
                                <TableCell>{data.email}</TableCell>
                                <TableCell>{data.tel}</TableCell>
                                <TableCell>{data.packageinfo}</TableCell>
                                <TableCell>{data.hour} ชั่วโมง</TableCell>
                                <TableCell>{data.price} บาท</TableCell>
                                <TableCell>{data.datecheckin}</TableCell>
                                <TableCell>
                                  <div>{data.check_in} น.</div>
                                </TableCell>
                                <TableCell>
                                  <div>{data.check_out} น.</div>
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    size="small"
                                    label={data.status}
                                    color={
                                      data.status === 'เสร็จสิ้น'
                                        ? 'success'
                                        : data.status === 'รอชำระเงิน'
                                          ? 'warning'
                                          : data.status === 'รอให้บริการ'
                                            ? 'info'
                                            : 'error'
                                    }
                                    sx={{ width: '100px' }}
                                  />
                                </TableCell>
                                <StyledTableCell>
                                  <Button
                                    size="medium"
                                    onClick={() => navigate('/thewonderblueadmin_room/view/' + data.roombooking_id)}
                                  >
                                    <MdPreview fontSize={'24px'} color='gray' />
                                  </Button>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                        </TableBody>
                      ) : (
                        <TableBody>
                          <StyledTableRow>
                            <TableCell colSpan={13} align="center">
                              ไม่พบข้อมูล
                            </TableCell>
                          </StyledTableRow>
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                  {Array.isArray(data) && data.length > 0 && (
                    <TablePagination
                      component="div"
                      count={data.length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[20]}
                      labelRowsPerPage="จำนวนรายการต่อหน้า"
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} จาก ${count}`}
                    />
                  )}
                </Paper>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default DashboardRoomTable_view;